import React from 'react';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import humanizeValue from '@utils/humanizeUtil';
import { getMetricUnitByKey } from '@utils/metrics';
import { StyledCell } from './styled';
import { getPrimaryKeyFromPercentageLocalKey } from '@src/utils/metrics/metricHelpers';
import { getTextColor } from '@src/utils/kpi/tools';

// TODO: duplicated from dimension panel cell
// cleanup as not all checks are required for roadmap

function ValueCell({ cellData, column }) {
  if (['NA', 'low'].includes(cellData)) {
    return <StyledCell>{cellData}</StyledCell>;
  }
  const textStyle: any = {};
  let classStr = '';

  if (!column.colorless && column.metric === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 500;
    classStr = 'color-critical';
  }

  const unit =
    column.mfPctChecked || !!getPrimaryKeyFromPercentageLocalKey({ metricKey: column.metric })
      ? '%'
      : getMetricUnitByKey({ metricKey: column.metric });
  const { humanizedNumber, humanizedUnit } = humanizeValue(cellData, column.metric, unit as string);

  return (
    <StyledCell>
      <span style={textStyle} className={classStr}>
        {`${humanizedNumber} ${humanizedUnit}`}
      </span>
    </StyledCell>
  );
}

export default React.memo(ValueCell);
